module.exports = __webpack_public_path__ + "static/media/12UNCTAD18.5f2912ce.jpg";